export default __webpack_public_path__ + "static/media/people.4ce479b9.svg";